import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
});

export function getSalonById(id, token) {
  return axios.get(`${API}/salons/${id}`, {
    headers: authHeaders(token),
  });
}

export function getAllSalons() {
  return axios.get(`${API}/salons`);
}

export async function searchSalons(params = {}) {
  const res = await axios.get(`${API}/salons/search`, { params });
  return res.data;
}

export async function searchSalonDirectory(params = {}) {
  const res = await axios.get(`${API}/salons/directory`, { params });
  return res.data;
}

export async function getSalonBooths(id) {
  const res = await axios.get(`${API}/salons/${id}/booths`);
  return res.data;
}

export async function createSalon(data, token) {
  const res = await axios.post(`${API}/salons/`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function patchMySalonProfile(data, token) {
  const res = await axios.patch(`${API}/salons/me`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function uploadSalonPhoto(salonId, file, token) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${API}/salons/${salonId}/photos/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token || null || ""}`,
    },
    body: formData,
  });

  if (!res.ok) {
    const txt = await res.text();
    console.error("Photo upload failed:", txt);
    throw new Error("Failed to upload photo");
  }

  return res.json();
}

export async function deleteSalonPhoto(salonId, url, token) {
  const res = await fetch(`${API}/salons/${salonId}/photos/delete`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token || null || ""}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ url }),
  });

  if (!res.ok) throw new Error("Failed to delete photo");
  return res.json();
}

export async function updateSalon(id, salonData, newPhotos = [], removedPhotos = [], token) {
  const formData = new FormData();
  formData.append("salon_data", JSON.stringify(salonData));

  newPhotos.forEach((file) => {
    formData.append("new_photos", file);
  });

  if (removedPhotos.length > 0) {
    formData.append("remove_photos", JSON.stringify(removedPhotos));
  }

  const res = await fetch(`${API}/salons/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token || null || ""}`,
    },
    body: formData,
  });

  if (!res.ok) {
    const txt = await res.text();
    console.error("Update failed:", txt);
    throw new Error("Failed to update salon");
  }

  return res.json();
}

export async function getMySalons(token) {
  const res = await axios.get(`${API}/salons/my-salons`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getMySalonHours(date, token) {
  const res = await axios.get(`${API}/salons/me/hours`, {
    params: { date },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getSalonHours(date, token) {
  return getMySalonHours(date, token);
}

export function deleteSalon(id, token) {
  return axios.delete(`${API}/salons/${id}`, {
    headers: authHeaders(token),
  });
}
